import { FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import { FormParagraphFormGroupField } from '@frontend/components/fields/FormParagraphField';
import type { IServiceOrganizationSettingFormSectionProps } from '../ServiceOrganizationSetting';
import { BittiumRecordingAnalyst } from '../../../../../../common/enums/bittiumRecordingAnalyst';
import { ServiceCode } from '../../../../../../common/enums/serviceCode';
import { translateKey } from '../../../../../translate';
import { EnumDropdownInput } from '../../../../fields/EnumDropdown';
import { InputTextField } from '../../../../userDataManagement/InputText';
import { ServiceOrganizationSettingFormMode } from '../ServiceOrganizationSetting';

export function SoftwareFormSection(props: IServiceOrganizationSettingFormSectionProps) {
    if (
        !(props.service.code === ServiceCode.TCOH && props.hasBiometricians) &&
        !(props.service.code === ServiceCode.TOO && props.hasServiceProviders)
    ) {
        return null;
    }

    return (
        <FormSection title={translateKey('serviceOrganizationSetting.software')}>
            {props.service.code === ServiceCode.TCOH && (
                <FormGroup label={translateKey('serviceOrganizationSetting.sendBittiumRecordingsTo')}>
                    {props.mode === ServiceOrganizationSettingFormMode.read ? (
                        <FormParagraph>
                            {props.sendBittiumRecordingsTo
                                ? translateKey(`bittiumRecordingAnalystEnum.${props.sendBittiumRecordingsTo}`)
                                : '-'}
                        </FormParagraph>
                    ) : (
                        <EnumDropdownInput
                            enumName="bittiumRecordingAnalyst"
                            error={props.errors.get('bittiumRecordingAnalyst')}
                            fieldKey="sendBittiumRecordingsTo"
                            jsEnum={BittiumRecordingAnalyst}
                            newstyles
                            placeholder={translateKey('organization.select')}
                        />
                    )}
                </FormGroup>
            )}

            {props.service.code === ServiceCode.TOO && (
                <>
                    {props.mode === ServiceOrganizationSettingFormMode.read ? (
                        <FormParagraphFormGroupField
                            fieldKey="optoConnectPracticeId"
                            label="serviceOrganizationSetting.optoConnectPracticeId"
                        />
                    ) : (
                        <InputTextField
                            error={props.errors.get('optoConnectPracticeId')}
                            fieldKey="optoConnectPracticeId"
                            hasErrors={props.errors.has('optoConnectPracticeId')}
                            label="serviceOrganizationSetting.optoConnectPracticeId"
                            nullable={true}
                            placeholder={translateKey('serviceOrganizationSetting.selectOptoConnectPracticeId')}
                        />
                    )}
                </>
            )}
        </FormSection>
    );
}
